import { useEffect } from 'react';
import { router } from '@/routes';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    __GA4_ID__?: string;
  }
}

/** Map apply paths to sign-up funnel steps */
const SIGN_UP_STEPS: Record<string, { step: number; name: string }> = {
  '/apply': { step: 1, name: 'your_car' },
  '/apply-two': { step: 2, name: 'personal_details' },
  '/apply-complete': { step: 3, name: 'why_join' },
};

/**
 * Tracks SPA route changes with GA4 via router.subscribe().
 * Works with createBrowserRouter (data router API).
 * Deduplicates by pathname to avoid double-firing on lazy route transitions.
 * Gracefully handles ad blockers and missing gtag.
 */
export function usePageTracking() {
  useEffect(() => {
    if (!window.__GA4_ID__) return;

    let lastTrackedPath = '';

    const unsubscribe = router.subscribe((state) => {
      if (state.navigation.state === 'idle' && window.gtag) {
        const pathname = state.location.pathname;

        // Deduplicate: lazy route transitions can fire idle multiple times
        if (pathname === lastTrackedPath) return;
        lastTrackedPath = pathname;

        window.gtag('event', 'page_view', {
          page_path: pathname + state.location.search,
          page_title: document.title,
        });

        // Fire sign-up funnel step event on apply pages
        const signUpStep = SIGN_UP_STEPS[pathname];
        if (signUpStep) {
          window.gtag('event', 'sign_up_step', {
            step: signUpStep.step,
            step_name: signUpStep.name,
          });
        }
      }
    });

    return unsubscribe;
  }, []);
}
